import { useState } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronRight } from '@fortawesome/pro-solid-svg-icons'

const ChildrenPicaboo = ({ children, padding = '8px', title, icon, defaultVisible = false }) => {
  const [visible, setVisible] = useState(defaultVisible)

  return (
    <div className='flex-col w-100'>
      <div className='flex-row w-100 cu-ptr' onClick={() => setVisible(!visible)}>
        {icon && (<FontAwesomeIcon icon={icon} className='mr-8' />)}
        {title && <b> {title} </b>}
        <div className='flex-fill' />
        <FontAwesomeIcon icon={visible ? faChevronDown : faChevronRight} />
      </div>
      <div style={{ padding: visible ? padding : 0 }}>
        {visible ? children : null}
      </div>
    </div>
  )
}

export default ChildrenPicaboo
